import { invoiceIsUnPaid } from './invoiceTableConfig';
import { BillingTableItem } from './types';

const calculateTotalBalance = (invoices: BillingTableItem[]) =>
  invoices.reduce((acc, current) => acc + current.Balance, 0);

export const useUnpaidBillingItems = (invoices: BillingTableItem[]) => {
  const unpaidInvoices = invoices.filter(invoiceIsUnPaid);
  const balance = calculateTotalBalance(unpaidInvoices);

  return { balance, unpaidInvoices };
};
